export default __webpack_public_path__ + "static/media/no-data.e1e9a126.svg";